<template>
  <div>
    <!-- 移动端遮罩层 -->
    <div class="menu-overlay" :class="{ 'show': isMenuOpen }" @click="isMenuOpen = false"></div>
    
    <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
      <!-- 顶部区域：Logo + 公司名称 + 电话 -->
      <div class="navbar-top">
        <div class="navbar-top-container">
          <!-- 左侧：Logo + 公司名称 -->
          <router-link to="/" class="navbar-logo">
            <img v-if="settings.site_logo" :src="settings.site_logo" :alt="settings.site_name" class="logo-img" />
            <img v-else src="@/assets/logo.png" alt="Logo" class="logo-img" />
            <span class="logo-text logo-text-full">{{ settings.site_name || '陕西慧安和信检测有限公司' }}</span>
            <span class="logo-text logo-text-mobile">{{ settings.site_name ? settings.site_name.substring(0, 4) : '慧安检测' }}</span>
          </router-link>

          <!-- 右侧：联系电话 -->
          <div class="contact-phone" v-if="settings.contact_phone">
            <span class="phone-label">服务热线：</span>
            <span class="phone-number">{{ settings.contact_phone }}</span>
          </div>
          
          <!-- 移动端菜单按钮 -->
          <div class="menu-toggle" @click="isMenuOpen = !isMenuOpen">
            <i :class="isMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
          </div>
        </div>
      </div>

      <!-- 底部区域：导航菜单 -->
      <div class="navbar-bottom">
        <div class="navbar-bottom-container">
          <!-- 桌面端导航菜单 -->
          <div class="navbar-menu navbar-menu-desktop">
          <template v-for="item in menuItems">
            <!-- 普通菜单项 -->
            <router-link 
              v-if="!item.children"
              :key="item.path" 
              :to="item.path"
              class="nav-item"
              :class="{ 'active': isActive(item.path) }"
              @click.native="isMenuOpen = false"
            >
              {{ item.name }}
            </router-link>
            
            <!-- 带下拉菜单的项 -->
            <div 
              v-else
              :key="item.name"
              class="nav-item-dropdown"
              @mouseenter="handleMouseEnter(item.name)"
              @mouseleave="handleMouseLeave"
            >
              <div 
                class="nav-item" 
                :class="{ 'active': isActive(item.activePath), 'has-dropdown': true, 'expanded': expandedMenus.includes(item.name) }"
                @click="toggleMobileMenu(item.name)"
              >
                {{ item.name }}
                <i class="el-icon-arrow-down dropdown-icon" :class="{ 'rotated': expandedMenus.includes(item.name) }"></i>
              </div>
              <div class="dropdown-menu" :class="{ 'show': activeDropdown === item.name || expandedMenus.includes(item.name) }">
                <router-link 
                  v-for="child in item.children"
                  :key="child.path"
                  :to="child.path"
                  class="dropdown-item"
                  @click.native="handleDropdownClick(child.path)"
                >
                  {{ child.name }}
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    </nav>
    
    <!-- 移动端导航菜单（独立） -->
    <div class="navbar-menu navbar-menu-mobile" :class="{ 'is-open': isMenuOpen }">
      <template v-for="item in menuItems">
        <!-- 普通菜单项 -->
        <router-link 
          v-if="!item.children"
          :key="item.path" 
          :to="item.path"
          class="nav-item"
          :class="{ 'active': isActive(item.path) }"
          @click.native="isMenuOpen = false"
        >
          {{ item.name }}
        </router-link>
        
        <!-- 带下拉菜单的项 -->
        <div 
          v-else
          :key="item.name"
          class="nav-item-dropdown"
        >
          <div 
            class="nav-item" 
            :class="{ 'active': isActive(item.activePath), 'has-dropdown': true, 'expanded': expandedMenus.includes(item.name) }"
            @click="toggleMobileMenu(item.name)"
          >
            {{ item.name }}
            <i class="el-icon-arrow-down dropdown-icon" :class="{ 'rotated': expandedMenus.includes(item.name) }"></i>
          </div>
          <div class="dropdown-menu" :class="{ 'show': expandedMenus.includes(item.name) }">
            <router-link 
              v-for="child in item.children"
              :key="child.path"
              :to="child.path"
              class="dropdown-item"
              @click.native="handleDropdownClick(child.path)"
            >
              {{ child.name }}
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getFullImageUrl } from '@/utils/imageUrl'
import settingsMixin from '@/mixins/settingsMixin'

export default {
  name: 'Navbar',
  mixins: [settingsMixin],
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false,
      activeDropdown: null,
      expandedMenus: [], // 用于移动端展开的菜单
      menuItems: [
        { path: '/', name: '首页' },
        { 
          name: '服务项目',
          activePath: '/service',
          children: [
            { path: '/air-breathing-apparatus', name: '空气呼吸器检测' },
            { path: '/gas-alarm-detector', name: '气体检测报警仪检测' },
            { path: '/gas-cylinder-detection', name: '气瓶定期检验' }
          ]
        },
        { path: '/baogao', name: '报告查询' },
        { path: '/project-cases', name: '项目案例' },
        { path: '/news', name: '新闻资讯' },
        { 
          name: '关于我们',
          activePath: '/about',
          children: [
            { path: '/about#company', name: '公司简介' },
            { path: '/about#culture', name: '企业文化' },
            { path: '/about#team', name: '组织架构' },
            { path: '/about#honors', name: '资质荣誉' }
          ]
        },
        { path: '/contact', name: '联系我们' }
      ]
    }
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
    },
    isActive(path) {
      // 处理首页的激活状态
      if (path === '/') {
        return this.$route.path === '/'
      }
      // 处理锚点链接（首页内的区域）
      if (path && path.startsWith('/#')) {
        return false // 锚点链接不高亮，只有首页路由才高亮
      }
      // 处理关于我们的子菜单
      if (path === '/about') {
        return this.$route.path.startsWith('/about')
      }
      // 处理服务项目菜单
      if (path === '/service') {
        return this.$route.path.includes('/air-breathing') || 
               this.$route.path.includes('/gas-alarm') || 
               this.$route.path.includes('/gas-cylinder')
      }
      // 处理其他路由
      if (path) {
        return this.$route.path.startsWith(path)
      }
      return false
    },
    handleMouseEnter(menuName) {
      if (window.innerWidth > 992) {
        this.activeDropdown = menuName
      }
    },
    handleMouseLeave() {
      if (window.innerWidth > 992) {
        this.activeDropdown = null
      }
    },
    toggleMobileMenu(menuName) {
      const index = this.expandedMenus.indexOf(menuName)
      if (index > -1) {
        this.expandedMenus.splice(index, 1)
      } else {
        this.expandedMenus.push(menuName)
      }
    },
    handleDropdownClick(path) {
      // 关闭移动端菜单
      this.isMenuOpen = false
      this.expandedMenus = []
      this.activeDropdown = null
      
      // 处理锚点跳转
      if (path.includes('#')) {
        const [routePath, hash] = path.split('#')
        
        // 如果当前已经在目标页面，直接滚动到锚点
        if (this.$route.path === routePath) {
          this.$nextTick(() => {
            const element = document.getElementById(hash)
            if (element) {
              const navbarHeight = 80 // 导航栏高度
              const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
              const offsetPosition = elementPosition - navbarHeight
              
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              })
            }
          })
        } else {
          // 如果需要先跳转到目标页面，则在路由跳转后再滚动
          this.$router.push(path).then(() => {
            this.$nextTick(() => {
              setTimeout(() => {
                const element = document.getElementById(hash)
                if (element) {
                  const navbarHeight = 80
                  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
                  const offsetPosition = elementPosition - navbarHeight
                  
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  })
                }
              }, 100) // 给页面一点时间渲染
            })
          })
        }
      }
    },
    getFullImageUrl
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
    this.fetchSettings()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    '$route'() {
      this.isMenuOpen = false
      this.expandedMenus = []
    }
  }
}
</script>

<style scoped>
.navbar {
  width: 100%;
  background-color: #fff;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.navbar-scrolled {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 顶部区域：Logo + 电话 */
.navbar-top {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 0;
}

.navbar-top-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 底部区域：导航菜单 */
.navbar-bottom {
  width: 100%;
  background-color: #fff;
  padding: 12px 0;
  position: relative;
}

.navbar-bottom-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo 样式 */
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  cursor: pointer;
}

.logo-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #1e3a8a;
  line-height: 32px;
  white-space: nowrap;
}

.logo-text-mobile {
  display: none;
}

.logo-text-full {
  display: inline;
}

/* 联系电话样式 */
.contact-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333333;
  white-space: nowrap;
}

.phone-label {
  font-size: 16px;
  font-weight: 500;
  color: #666666;
}

.phone-number {
  font-size: 24px;
  font-weight: 700;
  color: #1890ff;
  letter-spacing: 1px;
}

/* 导航菜单 */
.navbar-menu {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 0;
  flex: 1;
  padding: 0 20px;
}

/* 移动端菜单默认隐藏 */
.navbar-menu-mobile {
  display: none;
}

.nav-item {
  font-size: 16px;
  color: #333333;
  text-decoration: none;
  white-space: nowrap;
  padding: 10px 24px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  font-weight: 400;
  margin: 0 8px;
}

/* 添加竖线分隔 */
.nav-item::before {
  content: '|';
  position: absolute;
  left: -8px;
  color: #d0d0d0;
  font-weight: 300;
}

.nav-item:first-child::before {
  display: none;
}

.nav-item-dropdown .nav-item::before {
  display: block;
}

.nav-item-dropdown:first-child .nav-item::before {
  display: none;
}

.nav-item:hover {
  color: #1890ff;
  background: transparent;
}

.nav-item.active {
  color: #ffffff;
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 8px;
  font-weight: 500;
  padding: 10px 28px;
  margin: 0 12px;
}

.nav-item.active::before {
  display: none;
}

.nav-item.active::after {
  display: none;
}

/* 下拉菜单容器 */
.nav-item-dropdown {
  position: relative;
  cursor: pointer;
}

.nav-item.has-dropdown {
  cursor: pointer;
}

.dropdown-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.nav-item-dropdown:hover .dropdown-icon {
  transform: rotate(180deg);
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  background: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 1000;
  margin-top: 8px;
  border: 1px solid #e4e7ed;
}

.dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  padding: 12px 20px;
  font-size: 15px;
  color: #333333;
  text-decoration: none;
  transition: all 0.3s ease;
  white-space: nowrap;
  background: transparent;
  border-radius: 6px;
  margin: 2px 6px;
}

.dropdown-item:hover {
  background: linear-gradient(90deg, #e0f2fe 0%, #bae6fd 100%);
  color: #1e40af;
  padding-left: 24px;
}

/* 移动端菜单按钮 */
.menu-toggle {
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: #333333;
  background: none;
  border: none;
  padding: 8px;
  transition: color 0.3s;
}

.menu-toggle:hover {
  color: #1890ff;
}

.menu-toggle i {
  display: block;
}

/* 移动端遮罩层 */
.menu-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  opacity: 0;
  transition: opacity 0.3s;
}

.menu-overlay.show {
  display: block;
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .logo-text {
    font-size: 22px;
  }
  
  .logo-img {
    width: 50px;
    height: 50px;
  }
  
  .navbar-menu {
    padding: 0 10px;
  }
  
  .nav-item {
    font-size: 15px;
    padding: 10px 18px;
    margin: 0 6px;
  }
  
  .nav-item.active {
    padding: 10px 22px;
    margin: 0 10px;
  }
  
  .phone-number {
    font-size: 22px;
  }
}

@media (max-width: 1200px) {
  .logo-text {
    font-size: 20px;
  }
  
  .logo-img {
    width: 46px;
    height: 46px;
  }
  
  .navbar-menu {
    padding: 0 5px;
  }
  
  .nav-item {
    font-size: 14px;
    padding: 10px 14px;
    margin: 0 4px;
  }
  
  .nav-item.active {
    padding: 10px 18px;
    margin: 0 8px;
  }
  
  .phone-label {
    font-size: 14px;
  }
  
  .phone-number {
    font-size: 20px;
  }
}

@media (max-width: 992px) {
  /* 隐藏桌面端导航菜单 */
  .navbar-menu-desktop {
    display: none !important;
  }
  
  /* 显示移动端菜单按钮 */
  .menu-toggle {
    display: block;
  }
  
  /* 移动端菜单样式 */
  .navbar-menu-mobile.is-open {
    display: flex !important;
  }
  
  /* 调整顶部区域 */
  .navbar-top {
    padding: 12px 0;
  }
  
  .logo-img {
    width: 40px;
    height: 40px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  /* 联系电话：只显示数字 */
  .phone-label {
    display: none;
  }
  
  .phone-number {
    font-size: 18px;
  }
  
  .navbar-menu-mobile.is-open {
    display: flex !important;
    position: fixed !important;
    top: 64px !important;
    right: 0 !important;
    left: auto !important;
    width: 280px !important;
    max-height: calc(100vh - 64px) !important;
    background: #ffffff !important;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15) !important;
    border-left: 1px solid #e8e8e8 !important;
    overflow-y: auto !important;
    padding: 24px 0 !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0 !important;
    z-index: 1002 !important;
  }
  
  /* 移动端下拉菜单容器 */
  .navbar-menu-mobile.is-open .nav-item-dropdown {
    width: 100%;
  }
  
  .navbar-menu-mobile.is-open .nav-item {
    display: flex;
    justify-content: space-between;
    padding: 14px 20px;
    width: calc(100% - 32px);
    margin: 0 16px 8px 16px;
    font-size: 16px;
    border-radius: 8px;
    background: #f5f7fa;
    border: none;
  }
  
  /* 移动端隐藏竖线分隔符 */
  .navbar-menu-mobile.is-open .nav-item::before {
    display: none;
  }
  
  .navbar-menu-mobile.is-open .nav-item:hover {
    background: #1e3a8a;
    color: #ffffff;
    transform: none;
  }
  
  .navbar-menu-mobile.is-open .nav-item.active {
    color: #ffffff;
    background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  }
  
  .navbar-menu-mobile.is-open .nav-item.active::after {
    display: none;
  }
  
  .navbar-menu-mobile.is-open .nav-item.active::before {
    display: none;
  }
  
  /* 移动端下拉菜单样式 */
  .navbar-menu-mobile.is-open .dropdown-menu {
    position: static;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    margin-top: 0;
    background: transparent;
    max-height: 0;
    overflow: hidden;
    opacity: 1;
    visibility: visible;
    transform: none;
    transition: max-height 0.3s ease;
  }
  
  .navbar-menu-mobile.is-open .dropdown-menu.show {
    max-height: 500px;
  }
  
  .navbar-menu-mobile.is-open .dropdown-item {
    padding: 12px 20px 12px 36px;
    font-size: 15px;
    border-radius: 6px;
    background: transparent;
    margin: 4px 12px;
    border: none;
  }
  
  .navbar-menu-mobile.is-open .dropdown-item:last-child {
    margin-bottom: 8px;
  }
  
  .navbar-menu-mobile.is-open .dropdown-item:hover {
    background: linear-gradient(90deg, #e0f2fe 0%, #bae6fd 100%);
    color: #1e40af;
    transform: none;
  }
  
  /* 移动端下拉图标旋转 */
  .navbar-menu-mobile.is-open .dropdown-icon.rotated {
    transform: rotate(180deg);
  }
  
  /* 阻止移动端下拉菜单的hover效果 */
  .navbar-menu-mobile.is-open .nav-item-dropdown:hover .dropdown-icon {
    transform: none;
  }
  
  .navbar-menu-mobile.is-open .nav-item-dropdown .nav-item.expanded .dropdown-icon {
    transform: rotate(180deg);
  }
}

@media (max-width: 768px) {
  /* 调整顶部区域 */
  .navbar-top {
    padding: 12px 0;
  }
  
  .navbar-top-container {
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  
  .navbar-bottom-container {
    padding: 0 16px;
    justify-content: flex-end;
  }
  
  .navbar-bottom {
    padding: 8px 0;
  }
  
  /* 在移动端，隐藏navbar-bottom-container，但保留navbar-bottom以便菜单能正常显示 */
  .navbar-bottom-container {
    display: none;
  }
  
  .menu-toggle {
    font-size: 28px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: auto;
  }
  
  .navbar-logo {
    flex-shrink: 0;
    gap: 10px;
  }
  
  .logo-img {
    width: 34px;
    height: 34px;
  }
  
  .logo-text {
    font-size: 15px;
    font-weight: 600;
  }

  .logo-text-full {
    display: none;
  }

  .logo-text-mobile {
    display: inline;
  }
  
  .contact-phone {
    flex-shrink: 1;
    min-width: 0;
  }
  
  .phone-label {
    display: none;
  }
  
  .phone-number {
    font-size: 15px;
  }
  
  .navbar-menu-mobile.is-open {
    top: 58px !important;
    max-height: calc(100vh - 58px) !important;
    width: 260px !important;
  }
  
  .navbar-menu-mobile.is-open .nav-item {
    padding: 12px 16px;
    font-size: 15px;
    width: calc(100% - 24px);
    margin: 0 12px 6px 12px;
  }
  
  .navbar-menu-mobile.is-open .nav-item::before {
    display: none;
  }
  
  .navbar-menu-mobile.is-open .dropdown-item {
    padding: 10px 16px 10px 32px;
    font-size: 14px;
    margin: 3px 10px;
    background: transparent;
    border: none;
  }
  
  .navbar-menu-mobile.is-open .dropdown-item:hover {
    transform: none;
    background: linear-gradient(90deg, #e0f2fe 0%, #bae6fd 100%);
    color: #1e40af;
  }
}
</style> 